export function setMagazine1View(state, magazine) {
    magazine.forEach(element => {
        state.pages1.push(element.pageUrl)
    });
    setTimeout(() => {
        state.loading = false
    }, 2000);
}
export function setMagazine2View(state, magazine) {
    magazine.forEach(element => {
        state.pages2.push(element.pageUrl)
    });
    setTimeout(() => {
        state.loading = false
    }, 2000);
}
export function setMagazine3View(state, magazine) {
    magazine.forEach(element => {
        state.pages3.push(element.pageUrl)
    });
    setTimeout(() => {
        state.loading = false
    }, 2000);
}
export function setMagazine4View(state, magazine) {
    magazine.forEach(element => {
        state.pages4.push(element.pageUrl)
    });
    setTimeout(() => {
        state.loading = false
    }, 2000);
}

export function setMagazine5View(state, magazine) {
    magazine.forEach(element => {
        state.pages5.push(element.pageUrl)
    });
    setTimeout(() => {
        state.loading = false
    }, 2000);
}

export function setMagazine6View(state, magazine) {
    magazine.forEach(element => {
        state.pages6.push(element.pageUrl)
    });
    setTimeout(() => {
        state.loading = false
    }, 2000);
}
export function setMagazine7View(state, magazine) {   
    magazine.forEach(element => {        
        state.pages7.push(element.pageUrl)
    });
    setTimeout(() => {
        state.loading = false
    }, 2000);
}
export function setMagazine8View(state, magazine) {
    magazine.forEach(element => {
        state.pages8.push(element.pageUrl)
    });
    setTimeout(() => {
        state.loading = false
    }, 2000);
}
export function setMagazine9View(state, magazine) {
    magazine.forEach(element => {
        state.pages9.push(element.pageUrl)
    });
    setTimeout(() => {
        state.loading = false
    }, 2000);
}
export function setMagazine10View(state, magazine) {
    magazine.forEach(element => {
        state.pages10.push(element.pageUrl)
    });
    setTimeout(() => {
        state.loading = false
    }, 2000);
}
export function setMagazine11View(state, magazine) {
    magazine.forEach(element => {
        state.pages11.push(element.pageUrl)
    });
    setTimeout(() => {
        state.loading = false
    }, 2000);
}
export function setMagazine12View(state, magazine) {
    magazine.forEach(element => {
        state.pages12.push(element.pageUrl)
    });
    setTimeout(() => {
        state.loading = false
    }, 2000);
}

export function setMedia(state, media) {
    media.forEach(element => {
        state.media.push(element.mediaUrl)

    });
}

export function setClass(state, index) {
    state.index = index
}
export function verPlay(state, see) {
    state.audio.isPlaying = see
}
export function verPlayIssue6(state, see) {
    state.audioI6.isPlaying = see
}
export function listenAudioI7(state, see) {
    state.audioI7.isPlaying = see
}
export function listenAudioI12(state, see) {
    state.audioI12.isPlaying = see
}
export function verCover(state, cover) {   
    state.seeCover = cover
}